<template>
    <div class="content_item" v-on:click="youtube_on(item.youtube_address)">
        <img class="content_thumb" :src="src + item.youtube_thumbnail">
        <img class="logo" :src="src + item.logo">
        <div class="content_title">{{item.youtube_title}}</div>
        <div class="sub_text">조회수 {{item.view_count}}회 ㆍ {{item.created_at.split("T")[0]}}</div>
    </div>
</template>

<script>
import EventBus from "@/EventBus.js";
export default {
    props:["item"],
    methods:{
        youtube_on(id){
            console.log(id)
            EventBus.$emit("youtube_on",{"id":id})
        }
    }
}
</script>
<style scoped lang="scss">
.content_item{
    cursor: pointer;
    width: 250px;
    height:225px;
    .content_thumb{
        width: 250px;
        margin:2px;
        height: 140px;
    }
    .logo{
        width: 50px;
        height: 50px;
        border-radius: 30px;
        border:2px solid #fff;
        margin-top:0px; 
        float: left;
    }
    .content_title{
        float: left;
        width: 150px;
        font-size: 12px;
        margin-left: 10px;
        color:#0d0d0d;
        height: 55px;
    }
    .sub_text{
        color:#606060;
        font-size: 12px;
        padding-left: 5px;
        clear:both;
    }
}
</style>



// WEBPACK FOOTER //
// src/SPA/Main/Components/MainPublicContentsItemYoutube.vue